import type { AxiosRequestConfig } from 'axios'

/** Every definitions failure is rendered by its pane; none should trigger the shell's toast. */
export const DEFINITIONS_REQUEST_CONFIG: AxiosRequestConfig = {
  suppressGlobalErrorHandler: true,
  meta: { suppressGlobalErrorHandler: true },
}
